import { Component, EventEmitter, Input, Output } from '@angular/core';
import { S1ButtonType, S1UIService } from '@app/s1';
import { IAssistenza, StatoAssistenza } from '@app/shared/models/assistenza';
import { IUtente, RuoloUtente } from '@app/shared/models/utente';
import { AssistenzaService, IImpostaStatoAssistenzaParams } from '@app/shared/services/assistenza.service';
import { UtenteService } from '@app/shared/services/utente.service';

@Component({
  selector: 'ser-bottoni-stato-assistenza',
  templateUrl: './bottoni-stato-assistenza.component.html',
  styleUrl: './bottoni-stato-assistenza.component.scss'
})
export class BottoniStatoAssistenzaComponent {

  @Input() set assistenza(newValue: IAssistenza) {
    this._assistenza = newValue;
    this.mapButtonVisibility();
  };

  @Input() onlyIcon: boolean = false;

  @Output() updated = new EventEmitter<boolean>();

  s1ButtonType = S1ButtonType;
  statoAssistenza = StatoAssistenza;

  _assistenza: IAssistenza;
  _user: IUtente;

  buttonVisibility: {[key in StatoAssistenza]: boolean} = {
    Aperto: false,
    DaConfermare: false,
    Rifiutato: false,
    Confermato: false,
    ChiusoCasse: false,
    ChiusoPagamenti: false
  }

  constructor(private utenteService: UtenteService, private assistenzaService: AssistenzaService, private ui: S1UIService) {

    this.utenteService.getCurrentUser().subscribe(user => {

      this._user = user;
      this.mapButtonVisibility();

    })

  }

  askChangeStatus(stato: StatoAssistenza) {

    // il rifiuto richiede la motivazione, che viene salvata nelle note backoffice
    if (stato == StatoAssistenza.Rifiutato) {

      this.ui.showTextAreaPopup("assistenze.messages.motivazioneRifiuto", "assistenze.messages.motivazioneRifiutoObbligatoria").then(result => {

        if (result.isConfirmed && result.value?.trim()) {
          this.changeStatus(stato, result.value.trim());
        }

      })

      return;
    }

    this.ui.showDialogPopup("assistenze.messages.statusChange").then(result => {

      if (result.value) {

        this.changeStatus(stato);

      }

    })

  }

  private changeStatus(stato: StatoAssistenza, motivazione: string = null) {

    if (!this._assistenza.id) {
      return
    }

    const params: IImpostaStatoAssistenzaParams = {
      idAssistenza: this._assistenza?.id,
      stato: stato,
      motivazione: motivazione
    }

    this.assistenzaService.impostaStato(params).subscribe(changed => {

      if (changed) {
        this.ui.showSuccessToast("assistenze.messages.statusChanged");
        this.updated.emit(true);
      }

    })

  }

  private puoRifiutareAnchePostApprovazione(): boolean {
    return [StatoAssistenza.DaConfermare, StatoAssistenza.Confermato, StatoAssistenza.ChiusoCasse].includes(this._assistenza.stato);
  }

  mapButtonVisibility() {

    if (!this._assistenza || !this._user) {
      Object.keys(this.buttonVisibility).forEach(key => this.buttonVisibility[key] = false );
    } else {

      // Non c'è bottone "Apri"
      this.buttonVisibility.Aperto = false;

      switch (this._user.nomeRuolo) {

        case RuoloUtente.OPERATORE:
          this.buttonVisibility.DaConfermare = false;
          this.buttonVisibility.Rifiutato = false;
          this.buttonVisibility.Confermato = false;
          this.buttonVisibility.ChiusoCasse = false;
          this.buttonVisibility.ChiusoPagamenti = false;
          break;
        case RuoloUtente.SUPERVISORE:
          this.buttonVisibility.DaConfermare = false;
          this.buttonVisibility.Rifiutato = this._assistenza.stato == StatoAssistenza.DaConfermare;
          this.buttonVisibility.Confermato = this._assistenza.stato == StatoAssistenza.DaConfermare;
          this.buttonVisibility.ChiusoCasse = false;
          this.buttonVisibility.ChiusoPagamenti = false;
          break;
        case RuoloUtente.GESTIONE_CASSE:
          // Gestione Casse può approvare/rifiutare direttamente le assistenze in "Da confermare",
          // senza attendere la conferma del Supervisore (oltre a chiuderle da Confermato)
          this.buttonVisibility.DaConfermare = false;
          // Gestione Casse può rifiutare anche un'assistenza già confermata o chiusa casse (il rifiuto la toglie dai movimenti di cassa)
          this.buttonVisibility.Rifiutato = this.puoRifiutareAnchePostApprovazione();
          this.buttonVisibility.Confermato = this._assistenza.stato == StatoAssistenza.DaConfermare;
          // Le assistenze Rifiutate sono terminali: non proseguono il ciclo approvativo e non vanno chiuse
          this.buttonVisibility.ChiusoCasse = this._assistenza.stato == StatoAssistenza.Confermato;

          break;
        case RuoloUtente.GESTIONE_PAGAMENTI:
          this.buttonVisibility.DaConfermare = false;
          this.buttonVisibility.Rifiutato = false; //this._assistenza.stato == StatoAssistenza.Aperto || this._assistenza.stato == StatoAssistenza.DaConfermare;
          this.buttonVisibility.Confermato = false; //this._assistenza.stato == StatoAssistenza.Aperto || this._assistenza.stato == StatoAssistenza.DaConfermare;
          this.buttonVisibility.ChiusoCasse = false;
          this.buttonVisibility.ChiusoPagamenti = this._assistenza.stato == StatoAssistenza.ChiusoCasse;

          break;

        case RuoloUtente.SUPERUSER:
          this.buttonVisibility.DaConfermare = false;
          this.buttonVisibility.Rifiutato = this.puoRifiutareAnchePostApprovazione();
          this.buttonVisibility.Confermato = this._assistenza.stato == StatoAssistenza.DaConfermare;
          // Le assistenze Rifiutate sono terminali: non proseguono il ciclo approvativo e non vanno chiuse
          this.buttonVisibility.ChiusoCasse = this._assistenza.stato == StatoAssistenza.Confermato;
          this.buttonVisibility.ChiusoPagamenti = this._assistenza.stato == StatoAssistenza.ChiusoCasse;
          break;

      }

    }

  }

}
